var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.5C16.2835 15.5 15.5 16.2835 15.5 17.25C15.5 18.2165 16.2835 19 17.25 19C17.7335 19 18.1699 18.8049 18.4874 18.4874C18.8049 18.1699 19 17.7335 19 17.25C19 16.2835 18.2165 15.5 17.25 15.5ZM14 17.25C14 15.4551 15.4551 14 17.25 14C19.0449 14 20.5 15.4551 20.5 17.25C20.5 17.8754 20.3229 18.4602 20.0166 18.956L21.2803 20.2197C21.5732 20.5126 21.5732 20.9874 21.2803 21.2803C20.9874 21.5732 20.5126 21.5732 20.2197 21.2803L18.956 20.0166C18.4602 20.3229 17.8754 20.5 17.25 20.5C15.4551 20.5 14 19.0449 14 17.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C10.9155 4 12.9674 5.55718 13.7064 7.72247C14.3558 7.26719 15.1467 7 16 7C18.2091 7 20 8.79086 20 11C20 11.2443 19.9781 11.4836 19.9361 11.7158C21.1779 12.5168 22 13.9124 22 15.5C22 15.7952 21.9716 16.0837 21.9173 16.363C21.5019 14.1636 19.5702 12.5 17.25 12.5C14.6266 12.5 12.5 14.6266 12.5 17.25C12.5 18.2749 12.8246 19.2239 13.3766 20H6.5C4.01472 20 2 17.9853 2 15.5C2 14.1098 2.63045 12.8668 3.62104 12.0413C3.22431 11.2812 3 10.4168 3 9.5C3 6.46243 5.46243 4 8.5 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSearch2);
export default __webpack_public_path__ + "static/media/cloud-search-2.4b8e2e70aa6516c283f56082728caa86.svg";
export { ForwardRef as ReactComponent };